export default __webpack_public_path__ + "static/media/c002-PPII-12.e7e4f5eb.svg";